import { ReactElement } from 'react';
import { TableTopNotificationProps } from './TableTopNotification';
import { ComputedQuery, FiltersMap } from '@wix/bex-core';

export type TopNotificationRenderProp<F extends FiltersMap> =
  | ReactElement<TableTopNotificationProps>
  | ((params: {
      query: ComputedQuery<F>;
    }) => ReactElement<TableTopNotificationProps> | boolean | null | undefined)
  | boolean
  | null
  | undefined;

export type TopNotificationBasicRenderProp =
  | ReactElement<TableTopNotificationProps>
  | (() => ReactElement<TableTopNotificationProps> | boolean | null | undefined)
  | boolean
  | null
  | undefined;
